var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "event-students-dialog",
      attrs: { title: _vm.title, active: _vm.isVisible },
      on: {
        "update:active": function ($event) {
          _vm.isVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "students-container" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "loading-container" },
              [
                _c("vs-progress", {
                  attrs: { indeterminate: "", color: "primary" },
                }),
                _c("p", { staticClass: "loading-text" }, [
                  _vm._v(_vm._s(_vm.$t("common.loading"))),
                ]),
              ],
              1
            )
          : !_vm.loading && _vm.students.length === 0
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("feather-icon", {
                  staticClass: "empty-icon",
                  attrs: { icon: "UsersIcon" },
                }),
                _c("p", { staticClass: "empty-text" }, [
                  _vm._v(_vm._s(_vm.$t("lesson.no_students"))),
                ]),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "students-list" },
              _vm._l(_vm.students, function (student, index) {
                return _c(
                  "div",
                  { key: student.id || index, staticClass: "student-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "student-avatar" },
                      [
                        _c("feather-icon", {
                          staticClass: "avatar-icon",
                          attrs: { icon: "UserIcon" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "student-info" }, [
                      _c("span", { staticClass: "student-name" }, [
                        _vm._v(_vm._s(student.name)),
                      ]),
                      _c("span", { staticClass: "student-email" }, [
                        _vm._v(_vm._s(student.email)),
                      ]),
                    ]),
                    student.status
                      ? _c(
                          "div",
                          { staticClass: "student-status" },
                          [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: _vm.getStatusColor(student.status),
                                  pill: "",
                                },
                              },
                              [_vm._v(" " + _vm._s(student.status.label) + " ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
        !_vm.loading && _vm.students.length > 0
          ? _c("div", { staticClass: "footer-section" }, [
              _c(
                "div",
                { staticClass: "student-count" },
                [
                  _c("feather-icon", {
                    staticClass: "count-icon",
                    attrs: { icon: "UsersIcon" },
                  }),
                  _c("span", { staticClass: "count-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.students.length) +
                        " " +
                        _vm._s(
                          _vm.students.length === 1
                            ? _vm.$t("lesson.student")
                            : _vm.$t("lesson.students")
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }